var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right",class:{'big': _vm.size=='big', 'small': _vm.size=='small', 'good ': _vm.score >= 0, 'bad ': _vm.score < 0}},[_vm._v(_vm._s(_vm.score)+" ("+_vm._s(_vm.numCorrect)+"/"+_vm._s(_vm.numChoices)+") "+_vm._s(_vm.percentage)+"%")])
}
var staticRenderFns = []

export { render, staticRenderFns }